// extracted by mini-css-extract-plugin
export var dropdownButton = "_2b-0";
export var fullWidthDropdownButton = "_2b-1";
export var icon = "_2b-3";
export var iconPlaceholder = "_2b-2";
export var menuItemRow = "_2b-8";
export var separator = "_2b-d";
export var shortcutContainer = "_2b-7";
export var shortcutIconLg = "_2b-6";
export var shortcutIconMd = "_2b-5";
export var shortcutIconSm = "_2b-4";
export var submenuChevron = "_2b-c";
export var submenuDropdown = "_2b-9";
export var submenuTriggerRow = "_2b-a";
export var submenuTriggerRowOpen = "_2b-b";